import React, { useState } from "react";
import { Button, Col, Container, Form, Modal, Row } from "react-bootstrap";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";

import ApiHelper from "../../../Helpers/ApiHelper";
import Overlay from "../../SharedComponents/Overlay";

const PWD_Regex = /^(?=.*[a-z])(?=.*[^a-zA-Z\d\s:])(?=.*[A-Z])(?=.*[0-9]).{6,24}$/;

export function ResetPassword() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const userId = searchParams.get("u");
  const token = (searchParams.get("t") || "").replace(/ /g, "");

  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [validation, setValidation] = useState({ password: null, confirm: null });
  const [showOverlay, setShowOverlay] = useState(false);
  const [modal, setModal] = useState({ show: false, heading: "", text: "", success: false });

  const linkValid = Boolean(userId && token);

  const onPasswordChange = (value) => {
    setPassword(value);
    setValidation((v) => ({ ...v, password: !PWD_Regex.test(value) }));
  };

  const onConfirmChange = (value) => {
    setConfirm(value);
    setValidation((v) => ({ ...v, confirm: value !== password }));
  };

  const onSubmit = () => {
    setShowOverlay(true);
    ApiHelper.postAsync("user/ResetPassword", { userId, token, newPassword: password }, (result) => {
      setShowOverlay(false);
      if (result.status === 200 && result.data?.statusCode === 1) {
        setModal({
          show: true,
          heading: t("success") || "Başarılı",
          text: result.data?.message || "Şifreniz güncellendi.",
          success: true,
        });
      } else {
        setModal({
          show: true,
          heading: "Hata",
          text: result.data?.message || "Bağlantı geçersiz veya süresi dolmuş.",
          success: false,
        });
      }
    });
  };

  const closeModal = () => {
    setModal((m) => ({ ...m, show: false }));
    if (modal.success) navigate("/login");
  };

  const canSubmit = linkValid && validation.password === false && validation.confirm === false;

  return (
    <Container style={{ maxWidth: 480, marginTop: 80 }}>
      {showOverlay && <Overlay text="Şifre güncelleniyor" />}

      <h3 className="text-color-gray-dark fw-medium mb-4">Yeni Şifre Belirle</h3>

      {!linkValid ? (
        <p className="text-danger">Bozuk veya eksik bağlantı. Lütfen şifre sıfırlama e-postanızdaki bağlantıyı kullanın.</p>
      ) : (
        <Form>
          <Form.Group className="mb-3">
            <Form.Label className="text-color-gray-light">{t("password") || "Yeni Şifre"}</Form.Label>
            <Form.Control
              type="password"
              className="default-text-input"
              placeholder={t("yourPassword") || "Yeni şifreniz"}
              isInvalid={validation.password}
              onChange={(e) => onPasswordChange(e.target.value)}
              autoComplete="new-password"
            />
            <Form.Control.Feedback type="invalid">
              {t("passwordCheckRules") || "Şifre kurallara uygun olmalı."}
            </Form.Control.Feedback>
          </Form.Group>

          <Form.Group className="mb-4">
            <Form.Label className="text-color-gray-light">{t("passwordAgain") || "Şifre (Tekrar)"}</Form.Label>
            <Form.Control
              type="password"
              className="default-text-input"
              placeholder={t("pleaseEnterYourPasswordAgain") || "Şifrenizi tekrar girin"}
              isInvalid={validation.confirm}
              onChange={(e) => onConfirmChange(e.target.value)}
              autoComplete="new-password"
            />
            <Form.Control.Feedback type="invalid">
              {t("passwordsDoNotMatch") || "Şifreler eşleşmiyor."}
            </Form.Control.Feedback>
          </Form.Group>

          <Row>
            <Col>
              <Button className="button primary w-100 py-2" onClick={onSubmit} disabled={!canSubmit}>
                {t("send") || "Şifreyi Güncelle"}
              </Button>
            </Col>
          </Row>
        </Form>
      )}

      <Modal show={modal.show} onHide={closeModal} centered>
        <Modal.Header closeButton>
          <Modal.Title>{modal.heading}</Modal.Title>
        </Modal.Header>
        <Modal.Body>{modal.text}</Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={closeModal}>
            {modal.success ? t("login") || "Giriş Yap" : t("close") || "Kapat"}
          </Button>
        </Modal.Footer>
      </Modal>
    </Container>
  );
}
